import { render, staticRenderFns } from "./Sbujk.vue?vue&type=template&id=fc690182&"
import script from "./Sbujk.vue?vue&type=script&lang=js&"
export * from "./Sbujk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports